<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <Header back header-text="lng_consumption"></Header>
    <v-container fluid>
      <v-flex xs12 md12>
        <v-tabs
          v-model="model"
          centered
          color="transparent"
          slider-color="rgb(84,110,122)"
        >
          <v-tab
            v-for="tab in tabsData"
            :key="tab.param"
            :href="`#${tab.param}`"
          >
            {{ tab.tabItem }}
          </v-tab>
        </v-tabs>
        <!-- <v-tabs-items v-model="model">
          <v-tab-item
            v-for="tab in tabsData"
            :key="tab.param"
            :value="`${tab.param}`"
          >
            <Consumption-chart-item
              :chart-data="hoursData"
              :chart-name="tab.param"
            />
          </v-tab-item>
        </v-tabs-items> -->
        <div v-for="tab in tabsData" :key="tab.param">
          <div
            class="md-tab"
            v-if="model === tab.param && chartsData[`${model}`]"
          >
            <Consumption-chart-item
              :chart-data="chartsData[`${model}`]"
              :chart-name="model"
            />
          </div>
        </div>
      </v-flex>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import GlobalService from "../services/global-service";
import ConsumptionChartItem from "../components/ConsumptionChartItem";
import { translate } from "../common/HelperFunctions";

export default {
  components: {
    Header,
    ConsumptionChartItem
  },
  data: () => ({
    tabsData: [
      { param: "hours=24", tabItem: `24 ${translate("lng_consumption_0")}` },
      { param: "days=24", tabItem: `24 ${translate("lng_consumption_1")}` },
      { param: "months=12", tabItem: `12 ${translate("lng_consumption_2")}` },
      { param: "years=12", tabItem: `12 ${translate("lng_consumption_3")}` }
    ],
    model: "hours=24",
    chartsData: {},
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  }),
  async created() {
    // start page loading component
    this.$store.commit("global/setLoading", true);
    await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    async FetchApisData() {
      // this.chartsData['hours=24'] = await GlobalService.getConsumptionData( this.tabsData[0].param, this.getUser.token );
      this.$set(
        this.chartsData,
        "hours=24",
        await GlobalService.getConsumptionData(
          this.tabsData[0].param,
          this.getUser.token
        )
      );
      this.$set(
        this.chartsData,
        "days=24",
        await GlobalService.getConsumptionData(
          this.tabsData[1].param,
          this.getUser.token
        )
      );
      this.$set(
        this.chartsData,
        "months=12",
        await GlobalService.getConsumptionData(
          this.tabsData[2].param,
          this.getUser.token
        )
      );
      this.$set(
        this.chartsData,
        "years=12",
        await GlobalService.getConsumptionData(
          this.tabsData[3].param,
          this.getUser.token
        )
      );
      this.$store.commit("global/setLoading", false);
    }
  }
};
</script>
<style>
.v-tabs__div a {
  font-size: 14px;
  text-align: center;
  line-height: 24px;
  padding: 12px 24px;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  text-transform: uppercase;
  float: left;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 1 !important;
  color: rgba(0, 0, 0, 0.54) !important;
}
.v-tabs__div .v-tabs__item--active {
  color: rgb(84, 110, 122) !important;
}
.wrap-chart {
  max-width: 1000px;
  height: 430px;
  margin: 10px auto;
}
@media (max-width: 480px) {
  .wrap-chart {
    height: 350px;
  }
  .v-tabs__div {
    flex-wrap: wrap;
  }
  .v-tabs__div a {
    padding: 5px !important;
    font-size: 12px !important;
  }
}
</style>
